import { render, staticRenderFns } from "./embarazoActualShow.vue?vue&type=template&id=578acb64"
import script from "./embarazoActualShow.vue?vue&type=script&lang=js"
export * from "./embarazoActualShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports